import { combineReducers } from "redux";
import login from "./login-reducer";
import startup from "./startup-reducer";
import errors from "./error-reducer";

export default combineReducers({
  login,
  startup,
  errors
});
